import { MapReportListRepository } from '@/models/MapReport'
import { MapReportStatuses } from '@/models/MapReport'

const actions = {
  async INIT_SEARCH_ITEMS({ commit }) {
    commit('SET_KEYWORD', '')
    commit('SET_SEARCH_STATUS', MapReportStatuses.Waiting)
    commit('SET_SEARCH_AUTO_GENERATE_STATUS', null)
    commit('SET_PAGE_NO', 1)
  },

  async SET_SEARCH_KEYWORD({ commit }, keyword) {
    commit('SET_KEYWORD', keyword)
    commit('SET_PAGE_NO', 1)
  },

  async SET_SEARCH_PAGE_NO({ commit }, pageNo) {
    commit('SET_PAGE_NO', pageNo)
  },

  async SET_SEARCH_STATUS({ commit }, status) {
    commit('SET_SEARCH_STATUS', status)
    commit('SET_PAGE_NO', 1)
  },

  async SET_SEARCH_AUTO_GENERATE_STATUS({ commit }, autoGeneratedStatus) {
    commit('SET_SEARCH_AUTO_GENERATE_STATUS', autoGeneratedStatus)
    commit('SET_PAGE_NO', 1)
  },

  async SET_MAP_REPORT(
    { commit },
    { keyword, status, isAutoGenerated, pageNo },
  ) {
    const mapReport = await MapReportListRepository.getMapReportForAdmin(
      keyword,
      status,
      isAutoGenerated,
      pageNo,
    )
    commit('SET_MAP_REPORT', mapReport)
  },

  async RESET({ commit }) {
    commit('RESET')
  },
}

export default actions
